<script lang="ts">
import { defineComponent } from 'vue';
import { formatMoney } from '@/utils/format';

export default defineComponent({
  name: 'BetGuidsOverlay',
  methods: {
    formatMoney,
  },
  props: ['counters', 'text'],
});
</script>

<template>
  <div class="relative inline-block cursor-pointer" v-if="counters.guids?.length">
    <span class="text-teal-500 dark:text-teal-600 text-xs" v-html="text"></span>
    <div class="absolute left-0 bg-gray-700">
      <table class="basic-table border border-gray-600 dark:border-gray-400">
        <thead>
          <tr>
            <th>GUID</th>
            <th>пользователь</th>
            <th>ставка</th>
            <th>выигрыш</th>
          </tr>
        </thead>
        <tbody>
          <tr v-for="(guid, i) in counters.guids">
            <td class="text-nowrap">
              <router-link :to="`/calculator/${guid}`" class="underline text-blue-500">
                {{ guid }}
              </router-link>
            </td>
            <td class="text-nowrap">
              <router-link
                :to="`/bets?userId=${counters.users[i]}`"
                class="underline text-blue-500"
              >
                {{ counters.users[i] }}
              </router-link>
            </td>
            <td class="text-nowrap">
              {{ formatMoney(counters.stakes[i], 2, false) }}
            </td>
            <td class="text-nowrap">
              {{ formatMoney(counters.max_payouts[i], 2, false) }}
            </td>
          </tr>
        </tbody>
      </table>
    </div>
  </div>
</template>

<style scoped lang="scss">
.localOpacity {
  @apply opacity-40;

  &:hover {
    @apply opacity-100;
  }
}

.cursor-pointer > div {
  display: none;
}
.cursor-pointer:hover > div {
  display: block;
}
</style>
